export { PdpBreadcrumbsBar, type PdpBreadcrumbsBarProps } from './PdpBreadcrumbsBar';
